import { createSlice } from '@reduxjs/toolkit';

export type DashboardStepperState = {
  isNewDeclarationNeeded: boolean;
  hasModifiedEtablissements: boolean;
  hasModifiedRncps: boolean;
}

const initialState: DashboardStepperState = {
  isNewDeclarationNeeded: false,
  hasModifiedEtablissements: false,
  hasModifiedRncps: false,
};

const dashboardStepperSlice = createSlice({
  name: 'dashboardStepperSlice',
  initialState,
  reducers: {
    dontNeedNewDeclaration: (state: DashboardStepperState) => {
      state.isNewDeclarationNeeded = false;
    },
    needNewDeclaration: (state: DashboardStepperState) => {
      state.isNewDeclarationNeeded = true;
    },
    etablissementModified: (state: DashboardStepperState) => {
      state.hasModifiedEtablissements = true;
    },
    resetEtablissementModified: (state: DashboardStepperState) => {
      state.hasModifiedEtablissements = false;
    },
    rncpModified: (state: DashboardStepperState) => {
      state.hasModifiedRncps = true;
    },
    resetRncpModified: (state: DashboardStepperState) => {
      state.hasModifiedRncps = false;
    },
  },
});

export const {
  dontNeedNewDeclaration,
  needNewDeclaration,
  etablissementModified,
  resetEtablissementModified,
  rncpModified,
  resetRncpModified,
} = dashboardStepperSlice.actions;

export default dashboardStepperSlice.reducer;
